<template>
  <div>
    <Header page="request"/>
    <b-container>
      <div class="list-user--table list-files">
        <div class="header-table">
          <b-row>
            <b-col md="4">
              <h2 class="heading2">
                お問い合わせ
                <span>{{totalItems}}</span>
              </h2>
            </b-col>
            <b-col md="8">
              <div class="filter-wrapper">
                <b-form inline class="float-md-right">
                  <b-form-checkbox
                    stacked
                    class="mts-2 ml-2"
                    v-model="paginations.statusQuery"
                    @change="displayViewedRequest(paginations.statusQuery)"
                    :value="1"
                    :unchecked-value="0"
                  > 開封済みのお問い合わせを表示する</b-form-checkbox>
              </b-form>
              </div>
            </b-col>
          </b-row>
        </div>
        <div class="body-table">
          <table class="table table-csUser">
            <thead>
              <tr>
                <th scope="col" class="w-20">お名前</th>
                <th scope="col" class="hidden-mb w-20">要件</th>
                <th scope="col" class="w-20">会社名</th>
                <th scope="col" class="hidden-mb w-15">メール</th>
                <th scope="col" class="hidden-mb w-15">電話番号</th>
                <th scope="col" class="wider-click w-10"></th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="request in requests" v-bind:key="request.id"  @dblclick="detailRequest(request.id)" class="cursor-pointer">
                <td scope="row" class="table-name w-20">
                  <div class="table-name--box">
                    <div class="admin-name">
                      <div class="name name-bold">{{truncate(request.company_name,10,'...')}}</div>
                    </div>
                  </div>
                </td>
                <td class="table-department hidden-mb w-20">
                  {{truncate(request.requirement,10,'...')}}
                </td>
                <td class="table-role w-20">{{truncate(request.company_name,10,'...')}}</td>
                <td class="table-phone hidden-mb w-15">
                  {{truncate(request.email,15,'...')}}
                </td>
                <td class="hidden-mb w-15">
                  {{truncate(request.phone,13,'...')}}
                </td>
                <td class="table-action text-right wider-click w-10">
                  <b-dropdown class="dropdownAction" variant="link"  toggle-class="text-decoration-none" no-caret>
                    <template v-slot:button-content>
                      <i class="icon-i-dot"></i>
                    </template>
                    <b-dropdown-item  @click.prevent="detailRequest(request.id)">
                      <i class="icon-i-eyes"></i>
                      <span>開く</span>
                    </b-dropdown-item>
                    <b-dropdown-item @click="showModalDelete(request.id)">
                      <i class="icon-i-trash"></i>
                      <span>削除</span>
                    </b-dropdown-item>
                  </b-dropdown>
                </td>
              </tr>
            </tbody>
          </table>
          <nav aria-label="Page navigation" v-if="showPage">
            <ul class="pagination">
              <li class="page-item" :class="hasPrev"><a class="page-link prev" @click.prevent="changePage(paginations.page_index-1)"><i class="icon-i-prev"></i></a></li>
              <li class="page-item" v-for="page in pageNumber" v-bind:key="page"><a class="page-link" v-bind:class="{'active': page === paginations.page_index}" @click.prevent="changePage(page)">{{page}}</a></li>
              <li class="page-item" :class="hasNext"><a class="page-link next" @click.prevent="changePage(paginations.page_index+1)"><i class="icon-i-next"></i></a></li>
            </ul>
          </nav>
        </div>
      </div>
    </b-container>
    <modalDeleteRequest :idSelect="idSelect" />
  </div>
</template>

<script>
import Header from '@/components/share/Header'
import { BModal, VBModal } from 'bootstrap-vue'
import modalDeleteRequest from '@/views/Admin/Request/Delete'
import {mapState} from 'vuex'
export default {
  name: 'List',
  data () {
    return {
      idSelect: '',
      paginations: {
        page_index: 1,
        statusQuery: 0
      }
    }
  },
  components: {
    Header,
    BModal,
    modalDeleteRequest
  },
  methods: {
    detailRequest (id) {
      // For updating inquiry status to set as seen
      this.$store.dispatch('adminRequest/updateUserInquiry', {id: id})
      this.$router.push(`/admin/requests/${id}`)
    },
    showModalDelete (id) {
      this.idSelect = id
      this.$root.$emit('bv::show::modal', 'modalDeleteRequest', '#modalDeleteRequest')
    },
    changePage (pageIndex) {
      this.paginations.page_index = pageIndex
      this.$store.dispatch('adminRequest/getRequest', this.paginations)
    },
    displayViewedRequest (statusQuery) {
      this.paginations.statusQuery = statusQuery
      this.$store.dispatch('adminRequest/getRequest', this.paginations)
    }
  },
  directives: {
    // Note that Vue automatically prefixes directive names with `v-`
    'b-modal': VBModal
  },
  mounted () {
    this.$store.dispatch('adminRequest/getRequest', this.paginations)
  },
  computed: {
    ...mapState({
      requests: state => state.adminRequest.requests,
      totalPages: state => state.adminRequest.totalPages,
      totalItems: state => state.adminRequest.totalItems
    }),
    showPage () {
      return this.totalPages > 1
    },
    pageNumber () {
      const arr = []
      if (this.totalPages === 1) {
        return arr
      }
      const start = 1
      const end = this.totalPages
      const showPageCount = 6
      if (end <= showPageCount + 3) {
        for (let i = start; i <= end; i++) {
          arr.push({text: i, value: i})
        }
        return arr
      }
      arr.push({ text: start, value: start, show: '' })
      if (this.paginations.page_index >= 5) {
        arr.push({
          text: '...',
          value: '',
          show: 1
        })
      }
      let listStart = this.paginations.page_index - Math.floor(showPageCount / 2) + 1
      if (listStart <= 1) listStart = 2
      let listEnd = listStart + showPageCount - 1
      if (listEnd >= end) listEnd = end - 1
      listStart = listEnd - showPageCount + 1
      for (let i = listStart; i <= listEnd; i++) {
        arr.push({ text: i, value: i })
      }
      if (end - this.paginations.page_index >= showPageCount) {
        arr.push({
          text: '...',
          value: '',
          show: 2
        })
      }
      arr.push({ text: end, value: end, show: '' })
      arr.map((e, index) => {
        if (e.text === '...' && e.show === 2) {
          e.value = arr[index - 1].value + 1
        }
        if (e.text === '...' && e.show === 1) {
          e.value = arr[index + 1].value - 1
        }
        return e
      })
      return arr
    },
    hasPrev () {
      return this.paginations.page_index === 1 ? 'page-item-disabled' : ''
    },
    hasPagination () {
      return this.pageNumber.length > 1
    },
    hasNext () {
      return this.paginations.page_index === this.totalPages ? 'page-item-disabled' : ''
    }
  }
}
</script>

<style scoped lang="scss">
  .page-item-disabled {
    pointer-events: none;
  }
@import '@/assets/stylesheet/user/list_user.scss';
</style>



// WEBPACK FOOTER //
// src/views/Admin/Request/List.vue